var map = {
	"./address_image.svg": 162,
	"./animated_ashutosh.png": 163,
	"./animated_dinuka.png": 164,
	"./animated_logo.svg": 165,
	"./blogs_image.svg": 166,
	"./cloud_infrastructure.svg": 167,
	"./codeInLogo.png": 168,
	"./contactMail.png": 169,
	"./coursera_logo.png": 170,
	"./data_science.svg": 171,
	"./deeplearning_ai_logo.png": 172,
	"./delhivery_logo.png": 173,
	"./developerActivity.svg": 174,
	"./dsc_logo.png": 175,
	"./education.svg": 176,
	"./experience.svg": 177,
	"./feelingProud.svg": 178,
	"./freecopy_logo.png": 179,
	"./fullstack.svg": 180,
	"./gcp_logo.png": 181,
	"./github_logo.png": 182,
	"./googleAssistant.jpg": 183,
	"./googleAssistant.svg": 184,
	"./google_logo.png": 185,
	"./ibm_logo.png": 186,
	"./iiitk_logo.png": 187,
	"./intel_logo.jpg": 188,
	"./iu_logo.png": 189,
	"./jsFramework.svg": 190,
	"./legato_logo.png": 191,
	"./manOnTable.svg": 192,
	"./microsoft_logo.png": 193,
	"./mozilla_logo.png": 194,
	"./muffito_logo.png": 195,
	"./nextuLogo.jpg": 196,
	"./nptel_logo.png": 197,
	"./pic2_Isheni2.jpg": 198,
	"./pic2_kethmi.avif": 199,
	"./pic_Isheni.jpg": 92,
	"./pic_kethmi.jpg": 200,
	"./portfolio.gif": 201,
	"./programmer.svg": 202,
	"./projects_image.svg": 203,
	"./pwa.png": 204,
	"./saayaHealthLogo.png": 205,
	"./sliit-logoo.png": 206,
	"./stanford_logo.png": 207,
	"./talksCardBack.svg": 208,
	"./talksCardBackAlt.svg": 209,
	"./tiktok_logo.png": 210,
	"./ui_ux_design.svg": 211
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 53;